





















import { computed, defineComponent, Ref } from '@vue/composition-api';
import { CheckboxProps } from './types';

interface CheckboxBindings {
  checkBoxClass: Ref<string[]>;
  checked: Ref<boolean>;
  toggleChecked(): void;
}

export default defineComponent<CheckboxProps, CheckboxBindings>({
  name: 'Checkbox',
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const checked = computed<boolean>(() => !!props.value);

    return {
      checked,
      checkBoxClass: computed<string[]>(() => {
        const classes = [];

        if (checked.value) {
          classes.push('checked');
        }

        return classes;
      }),
      toggleChecked() {
        context.emit('input', !checked.value);
      },
    };
  },
});
